import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { VideoSearch as NYYVideoSearch, mapPlaylistFromVideoSearch, styles } from 'yankees-react-utils';
import { useOktaQuery, VideoSearch as vSearch, Video } from '../../data';
import useConfig from '../../utils/useConfig';
import VideoPlayerAdvanced from '../../components/VideoPlayerAdvanced';
import PlayerSearch from '../../components/PlayerSearch';
import TeamSearch from '../../components/TeamSearch';
import { store } from '../../store';

const StyledVideoSearchContainer = styled.div`
    margin: -${styles.theme.margin.body};
    width: calc(100% + 2 * ${styles.theme.margin.body});
    height: calc(100% + 2 * ${styles.theme.margin.body});
`;

const VideoSearch = ({ initSearch }) => {
    const { state: { user } } = useContext(store);
    const { CurrentYear } = useConfig();
    const { authState: { accessToken }, data: savedSearches, refetch: refreshSearches } = useOktaQuery('video-searches', vSearch.get);
    let abortController = null;

    const search = async (form) => {
        try {
            if (abortController) {
                abortController.abort();
            }
            abortController = new AbortController();
            delete form.Type;
            const resp = await Video.search(accessToken, form, { signal: abortController.signal });
            return mapPlaylistFromVideoSearch(resp, user.Roles.map((r) => r.RoleName));
        } catch (error) {
            if (error.name !== 'AbortError') {
                throw error;
            }
        }
        return [];
    };
    const create = async (form) => {
        const newSearch = await vSearch.create(accessToken, form);
        await refreshSearches();
        return newSearch;
    };
    const update = async (form) => {
        const updatedSearch = await vSearch.update(accessToken, form.VideoSearchID, form);
        await refreshSearches();
        return updatedSearch;
    };
    const remove = async (videoSearchID) => {
        await vSearch.delete(accessToken, videoSearchID);
        refreshSearches();
    };

    return (
        <StyledVideoSearchContainer>
            <NYYVideoSearch
                yearId={CurrentYear}
                search={search}
                videoPlayer={VideoPlayerAdvanced}
                playerSearch={PlayerSearch}
                teamSearch={TeamSearch}
                savedSearches={savedSearches}
                create={create}
                update={update}
                delete={remove}
                initSearch={initSearch}
                alwaysShowFilter={false}
                hideDownload
                hideShare
                hideFrameGrab
                hideAmateurLevels
            />
        </StyledVideoSearchContainer>
    );
};

VideoSearch.propTypes = {
    initSearch: PropTypes.shape({}),
};
VideoSearch.defaultProps = {
    initSearch: undefined,
};

export default VideoSearch;
